import React from 'react';

import { ArcGISIdentityManager } from '@esri/arcgis-rest-request';
import { useEffect } from 'react';
const localOptionsKey = 'arcgis_auth_options';
export function useAuthenticationCallback() {
  // Hash only updates when login is complete
  useEffect(() => {
    const opts = localStorage.getItem(localOptionsKey);
    if (opts) {
      localStorage.removeItem(localOptionsKey);

      ArcGISIdentityManager.completeOAuth2(JSON.parse(opts));
    }
  }, []);
}

export default function Authenticate() {
  useAuthenticationCallback();
  return (
    <div>Feel free to close this page if it does not automatically close</div>
  );
}
